export default "__VITE_PUBLIC_ASSET__bedf8078__"